import '../static/List.css';
import React__default, { memo } from "react";
import clsx from "clsx";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
const list = `_list_a25f2c3`;
const listIcon = `_listIcon_7d9a341`;
const bullet = `_bullet_dd74e1b`;
const number = `_number_969b834`;
const minimal = `_minimal_2cc278b`;
const icon = `_icon_2b3fcd3`;
const styles = { list, listIcon, bullet, number, minimal, icon };
const LIST_VARIANTS = ["bullet", "number", "minimal", "icon"];
const List = memo(
  ({ as, className, icon: icon2, items, variant = LIST_VARIANTS[0], ...props }) => {
    const TagName = useTagName(as || variant === "number" ? "ol" : "ul");
    return /* @__PURE__ */ React__default.createElement(
      TagName,
      {
        ...props,
        className: clsx(styles.list, styles[variant], className)
      },
      items.map((item, index) => /* @__PURE__ */ React__default.createElement("li", { key: index }, variant === "icon" && icon2 && /* @__PURE__ */ React__default.createElement(
        "span",
        {
          "aria-hidden": "true",
          "data-testid": "list-icon",
          className: styles.listIcon
        },
        icon2
      ), item))
    );
  }
);
export {
  List as L
};
//# sourceMappingURL=List.DA5sxQBI.mjs.map
